import { useState, useEffect, useCallback, useRef } from "react";
import { Link } from "react-router-dom";

interface Slide {
  image: string;
  headline: string;
  subtext: string;
  stat: { value: string; label: string };
}

const slides: Slide[] = [
  {
    image: "https://readdy.ai/api/search-image?query=Modern%20bright%20fitness%20studio%20interior%20with%20natural%20daylight%20streaming%20through%20large%20windows%2C%20row%20of%20treadmills%20and%20weight%20equipment%20arranged%20neatly%20on%20polished%20concrete%20floor%2C%20indoor%20plants%20adding%20greenery%2C%20warm%20atmosphere%2C%20clean%20minimalist%20aesthetic%2C%20empty%20gym%20ready%20for%20members%2C%20professional%20interior%20photography%2C%20soft%20shadows%2C%20warm%20neutral%20tones%2C%20high%20resolution%204K%20quality&width=1920&height=800&seq=getfit-slide-1&orientation=landscape",
    headline: "Run your gym like a business, not a side hustle.",
    subtext: "Member management, class scheduling, billing, and multi-branch analytics \u2014 all in one platform built for fitness operators.",
    stat: { value: "All-in-one", label: "Gym management" },
  },
  {
    image: "https://readdy.ai/api/search-image?query=Group%20fitness%20class%20in%20a%20bright%20modern%20studio%20with%20natural%20light%2C%20diverse%20people%20working%20out%20together%20on%20yoga%20mats%2C%20instructor%20guiding%20session%2C%20energetic%20and%20motivating%20atmosphere%2C%20clean%20wooden%20floors%2C%20large%20mirrors%20on%20walls%2C%20plants%20in%20corners%2C%20wellness%20and%20community%20vibe%2C%20professional%20fitness%20photography%2C%20warm%20lighting%2C%20high%20resolution%204K%20quality&width=1920&height=800&seq=getfit-slide-2&orientation=landscape",
    headline: "Give your members an experience they\u2019ll pay to keep.",
    subtext: "Self-service booking, automated reminders, progress tracking, and personalised class recommendations that keep retention high.",
    stat: { value: "Member-first", label: "Experience platform" },
  },
  {
    image: "https://readdy.ai/api/search-image?query=Modern%20fitness%20reception%20desk%20with%20tablet%20showing%20class%20schedule%20dashboard%20on%20screen%2C%20bright%20and%20welcoming%20entrance%20with%20plants%2C%20clean%20white%20walls%2C%20natural%20light%20from%20glass%20doors%2C%20organised%20professional%20atmosphere%2C%20small%20gym%20check%20in%20counter%2C%20warm%20inviting%20space%2C%20professional%20interior%20photography%2C%20high%20resolution%204K%20quality&width=1920&height=800&seq=getfit-slide-3&orientation=landscape",
    headline: "Scheduling that works as hard as your trainers do.",
    subtext: "Smart class scheduling with capacity management, waitlist automation, trainer assignments, and real-time occupancy across all your studios.",
    stat: { value: "Smart", label: "Class scheduling" },
  },
  {
    image: "https://readdy.ai/api/search-image?query=Open%20plan%20fitness%20brand%20headquarters%20office%20with%20large%20wall%20mounted%20screens%20showing%20gym%20performance%20dashboards%20and%20analytics%20charts%2C%20modern%20workspace%20with%20standing%20desks%20and%20indoor%20plants%2C%20team%20of%20diverse%20professionals%20reviewing%20data%2C%20bright%20natural%20daylight%2C%20clean%20contemporary%20design%2C%20professional%20corporate%20fitness%20tech%20environment%2C%20warm%20lighting%2C%20high%20resolution%204K%20quality&width=1920&height=800&seq=getfit-slide-4&orientation=landscape",
    headline: "One dashboard. Every location. Total clarity.",
    subtext: "See revenue, attendance, utilisation, and churn across every branch in one view. Make decisions based on data, not gut feel.",
    stat: { value: "Multi-branch", label: "Analytics & insights" },
  },
  {
    image: "https://readdy.ai/api/search-image?query=Fitness%20trainer%20working%20one%20on%20one%20with%20client%20in%20bright%20modern%20gym%2C%20trainer%20demonstrating%20proper%20form%20on%20cable%20machine%2C%20both%20engaged%20and%20focused%2C%20clean%20gym%20environment%20with%20mirrors%20and%20equipment%20background%2C%20professional%20supportive%20coaching%20atmosphere%2C%20natural%20daylight%2C%20warm%20inviting%20tones%2C%20professional%20fitness%20photography%2C%20high%20resolution%204K%20quality&width=1920&height=800&seq=getfit-slide-5&orientation=landscape",
    headline: "Your trainers run the floor. The platform runs the rest.",
    subtext: "Staff scheduling, payroll tracking, client session logging, and performance reviews \u2014 so your team can focus on what they do best.",
    stat: { value: "Staff-ready", label: "Team management" },
  },
  {
    image: "https://readdy.ai/api/search-image?query=Modern%20fitness%20technology%20product%20showcase%20with%20laptop%20and%20tablet%20displaying%20sleek%20dark%20themed%20fitness%20management%20dashboard%20with%20member%20profiles%2C%20class%20schedules%2C%20attendance%20charts%20on%20screen%2C%20clean%20wooden%20desk%20with%20dumbbell%20and%20towel%2C%20bright%20airy%20gym%20background%20softly%20blurred%2C%20warm%20natural%20daylight%2C%20professional%20product%20photography%2C%20crisp%20modern%20aesthetic%2C%20high%20resolution%204K%20quality&width=1920&height=800&seq=getfit-slide-6&orientation=landscape",
    headline: "Meet Get Fit \u2014 the platform fitness businesses deserve.",
    subtext: "Purpose-built vertical SaaS for gyms, studios, and wellness centres. Not a generic tool stretched to fit. Not a spreadsheet dressed up as software.",
    stat: { value: "Get Fit", label: "Vertical SaaS for fitness" },
  },
  {
    image: "https://readdy.ai/api/search-image?query=Happy%20diverse%20group%20of%20fitness%20members%20celebrating%20after%20a%20workout%20in%20a%20bright%20modern%20gym%2C%20high%20fives%20and%20smiles%2C%20sense%20of%20community%20and%20achievement%2C%20clean%20spacious%20studio%20with%20natural%20light%2C%20energy%20and%20motivation%20visible%2C%20professional%20fitness%20lifestyle%20photography%2C%20warm%20vibrant%20tones%2C%20high%20resolution%204K%20quality&width=1920&height=800&seq=getfit-slide-7&orientation=landscape",
    headline: "Your community grows when your systems don\u2019t get in the way.",
    subtext: "Automate the busywork. Free your team to build relationships that keep members coming back month after month.",
    stat: { value: "Community", label: "Member retention" },
  },
];

export default function GetFitCarousel() {
  const [active, setActive] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef<number | null>(null);

  const next = useCallback(
    () => setActive((prev) => (prev + 1) % slides.length),
    []
  );
  const prev = useCallback(
    () => setActive((p) => (p - 1 + slides.length) % slides.length),
    []
  );

  useEffect(() => {
    if (isPaused) return;
    const id = setInterval(next, 5000);
    return () => clearInterval(id);
  }, [next, isPaused]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [prev, next]);

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) next();
      else prev();
    }
    touchStartX.current = null;
  };

  return (
    <section className="relative py-16 md:py-24 bg-graphite-950">
      <div className="section-padding">
        <div className="max-w-6xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-emerald-accent/30 bg-emerald-accent/10 mb-5">
              <span className="w-5 h-5 flex items-center justify-center rounded-full bg-emerald-accent/20">
                <i className="ri-heart-pulse-line text-emerald-accent text-xs" />
              </span>
              <span className="text-xs font-semibold text-emerald-accent tracking-wide">
                Get Fit
              </span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
              Purpose-Built for{" "}
              <span className="text-emerald-accent">Fitness Businesses</span>
            </h2>
            <p className="text-base sm:text-lg text-silver-300 max-w-2xl mx-auto leading-relaxed">
              Vertical SaaS designed for gyms, studios, wellness centres, and fitness communities. Not a generic tool hacked to fit.
            </p>
          </div>

          {/* Carousel */}
          <div
            className="relative rounded-xl overflow-hidden bg-graphite-800/60 border border-graphite-700/50 h-[360px] md:h-[440px] select-none"
            aria-roledescription="carousel"
            aria-label="Get Fit fitness platform features"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            {/* Slides */}
            <div className="relative w-full h-full">
              {slides.map((slide, i) => (
                <div
                  key={i}
                  className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
                    i === active ? "opacity-100 z-[1]" : "opacity-0 z-0"
                  }`}
                  aria-hidden={i !== active}
                >
                  {/* Image */}
                  <img
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover object-top"
                    loading={i === 0 ? "eager" : "lazy"}
                    src={slide.image}
                  />
                  {/* Gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-r from-graphite-900/95 via-graphite-900/70 to-graphite-900/40" />
                  <div className="absolute inset-0 bg-gradient-to-t from-graphite-900/50 via-transparent to-transparent" />

                  {/* Content */}
                  <div className="relative z-10 h-full flex items-center">
                    <div className="w-full px-6 md:px-10 lg:px-14 py-8 md:py-12">
                      <div className="max-w-lg">
                        {/* Stat badge */}
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-accent/10 border border-emerald-accent/20 mb-4 md:mb-6">
                          <span className="text-sm font-bold text-emerald-accent">{slide.stat.value}</span>
                          <span className="w-px h-3 bg-emerald-accent/30" />
                          <span className="text-xs text-emerald-soft">{slide.stat.label}</span>
                        </div>

                        <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight mb-3 md:mb-4">
                          {slide.headline}
                        </h3>
                        <p className="text-sm sm:text-base text-silver-300 max-w-md leading-relaxed mb-6 md:mb-8">
                          {slide.subtext}
                        </p>
                        <Link
                          to="/products/get-fit"
                          className="inline-flex items-center gap-2 px-5 py-2.5 bg-emerald-accent text-white font-semibold text-sm rounded-lg transition-colors duration-200 hover:bg-emerald-hover whitespace-nowrap"
                        >
                          Explore Get Fit
                          <span className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-arrow-right-line text-sm" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Arrow navigation */}
            <button
              className="hidden md:flex absolute left-3 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-graphite-900/70 backdrop-blur-sm border border-graphite-600/50 text-white/70 hover:bg-emerald-accent/20 hover:text-white hover:border-emerald-accent/30 transition-all duration-300 cursor-pointer"
              aria-label="Previous slide"
              onClick={prev}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-left-s-line text-lg" />
              </span>
            </button>
            <button
              className="hidden md:flex absolute right-3 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-graphite-900/70 backdrop-blur-sm border border-graphite-600/50 text-white/70 hover:bg-emerald-accent/20 hover:text-white hover:border-emerald-accent/30 transition-all duration-300 cursor-pointer"
              aria-label="Next slide"
              onClick={next}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-lg" />
              </span>
            </button>

            {/* Dot indicators */}
            <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
              {slides.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActive(i)}
                  className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                    i === active
                      ? "w-6 bg-emerald-accent"
                      : "w-2 bg-graphite-500 hover:bg-graphite-400"
                  }`}
                  aria-label={`Go to slide ${i + 1}`}
                  aria-current={i === active ? "true" : undefined}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}